import React from 'react';
import kebabCase from 'lodash/kebabCase';
import { RouteType } from '@Pages/RetroSynthesis/constants';
import { ButtonWithIcon } from '@els/els-react--button';

function ConditionsButton({ conditionsIsShown, setConditionsIsShown, routeType }) {
  const onClickHandler = () => {
    setConditionsIsShown(!conditionsIsShown);
  };

  const label = routeType === RouteType.PREDICTED ? 'Reaxys Examples' : 'conditions';
  const buttonProps = conditionsIsShown
    ? {
        sprite: 'EyeNotVisible',
        className: `e2e-rs-toolbar-button-hide-${kebabCase(label)}`,
        children: `Hide ${label}`,
      }
    : {
        sprite: 'EyeVisible',
        className: `e2e-rs-toolbar-button-show-${kebabCase(label)}`,
        children: `Show ${label}`,
      };

  return <ButtonWithIcon layout="vertical" type="borderless" size="small" onClick={onClickHandler} {...buttonProps} />;
}

export default ConditionsButton;
